/**
 * app-badge.ts — Số tin chưa đọc trên biểu tượng ứng dụng đã cài (Badging API: Android Chrome, Chrome/Edge máy tính,
 * Safari iOS 16.4+ khi đã thêm vào Màn hình chính). Trình duyệt không hỗ trợ → không làm gì.
 */
export const badgeCount = (unread: number | null | undefined): number =>
  typeof unread === 'number' && Number.isFinite(unread) && unread > 0 ? Math.floor(unread) : 0

type BadgeNav = { setAppBadge?: (n?: number) => Promise<void>; clearAppBadge?: () => Promise<void> }

/** Đặt số (0 = xoá). Mọi lỗi đều nuốt: huy hiệu chỉ là phần thêm. */
export async function setAppBadgeCount(unread: number | null | undefined, nav: BadgeNav = navigator as BadgeNav): Promise<void> {
  const n = badgeCount(unread)
  try {
    if (n > 0) await nav.setAppBadge?.(n)
    else await nav.clearAppBadge?.()
  } catch { /* không hỗ trợ / bị chặn */ }
}
